var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.myitems,"hide-default-header":""},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var headers = ref.props.headers;
return [_c('thead',[_c('tr',_vm._l((headers),function(h,index){return _c('th',{key:index,staticClass:"column sortable desc active",class:h.class},[_c('span',[_vm._v(_vm._s(h.text))])])}),0)])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }